import React from 'react'
import { Route } from 'react-router-dom'
import PropTypes from 'prop-types'
import { Container, makeStyles } from '@material-ui/core'

const useClasses = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1)
  }
}))


export default function RouteWrapper({ component, withContainer = true, ...rest }) {
  const classes = useClasses()

  const renderRoute = () => <Route component={component} { ...rest } />

  if(withContainer) {
    return (
      <Container margin={3} padding={6} className={classes.container}>
        {renderRoute()}
      </Container>
    )
  } else {
    return renderRoute()
  }
}

RouteWrapper.propTypes = {
  component: PropTypes.func.isRequired,
  withContainer: PropTypes.bool
}
